<div class="header">
  <div class="header-inner">
    <nav class="navbar navbar-expand-lg navbar-light bg-light shadow-sm navbar fixed-top header-nav">
      <div class="container">
        <div class="logo hide-mobile color-logo">
          <a class="navbar-brand" routerLink="/dashboard">
            <img src="/assets/images/botlogo.png" alt="logo" width="60" class="color-logo">
          </a>
          <!-- <a class="navbar-brand" routerLink="/dashboard">
          <img src="/assets/images/diwali.gif" alt="logo" width="70" style="margin-top: 5px;">
        </a> -->
      </div>
      <div class="logo show-mobile">
        <a class="navbar-brand mx-0" routerLink="/dashboard">
          <img src="/assets/images/bot-logo-mobile.png" alt="logo" width="15">
        </a>
      </div>

      <div class="collapse navbar-collapse justify-content-end align-items-center hide-mobile"
        id="navbarNavDropdown">

        <ul class="navbar-nav justify-content-center">
          <div class="position-relative">
            <li class="nav-item active dash-name position-absolute">
              <a class="nav-link me-4 text-secondary" routerLink="/dashboard"
              routerLinkActive="active">Dashboard</a>
            </li>
          </div>
          <!-- <li class="nav-item">
          <a class="nav-link" href="#">Portfolio</a>
        </li>
        <li class="nav-item">
          <a class="nav-link" href="#">Pricing</a>
        </li> -->
        <div class="position-relative">
          <li class="nav-item dropdown port-name position-absolute">
            <a class="nav-link dropdown-toggle me-4" id="navbarDropdownMenuLink" role="button"
              data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
              <!-- (click)="clickEvent()" -->
              Portfolio
            </a>
            <div aria-labelledby="navbarDropdownMenuLink" [ngClass]="toggleMenu? 'mnu-closed' : ''">
              <div class="empty-space-port"></div>
              <div class="dropdown-menu border-0 shadow mt-n3">
                <li><a class="dropdown-item text-secondary nav-link" routerLink="/portfolio/position"
                routerLinkActive="active">Positions</a></li>
                <li><a class="dropdown-item text-secondary nav-link" routerLink="/portfolio/holdings"
                routerLinkActive="active">Holdings</a></li>
                <!-- Uat -->
                <li><a class="dropdown-item text-secondary nav-link"
                  href="https://rise.aliceblueonline.com/ipo" (click)="getClevertapIPOS()"
                target="_blank">IPO's</a></li>
                <!-- prod -->
                <!-- <li><a class="dropdown-item text-secondary nav-link"
              href="https://rise.aliceblueonline.com/explore/ipo" target="_blank">IPO's</a></li> -->

              <li><a class="dropdown-item text-secondary nav-link"
                routerLink="/portfolio/corporate-action" routerLinkActive="active">Corporate
              Action</a></li>
              <li><a class="dropdown-item text-secondary nav-link" routerLink="/portfolio/tags-analyse"
              routerLinkActive="active">Tags</a></li>
            </div>
          </div>
        </li>
      </div>

      <div class="position-relative">
        <li class="nav-item dropdown report-name position-absolute">
          <a class="nav-link dropdown-toggle me-4" id="navbarDropdownMenuLink" role="button"
            data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
            <!-- (click)="clickEvent()" -->
            Report
          </a>
          <div class="" aria-labelledby="navbarDropdownMenuLink" [ngClass]="toggleMenu? 'mnu-closed' : ''">
            <div class="empty-space-report"></div>
            <div class="dropdown-menu border-0 shadow  mt-n3">
              <li><a class="dropdown-item text-secondary nav-link" routerLink="/reports/pnl"
              routerLinkActive="active">P&L</a></li>
              <li><a class="dropdown-item text-secondary nav-link" routerLink="/reports/tax-pnl"
              routerLinkActive="active">Tax P&L</a></li>
              <!-- <li><a class="dropdown-item text-secondary nav-link" routerLink="/reports/tax-loss-harvesting"
            routerLinkActive="active">Tax-loss harvesting</a></li> -->
            <li><a class="dropdown-item text-secondary nav-link" routerLink="/reports/download"
            routerLinkActive="active">Downloads</a></li>
            <li><a class="dropdown-item text-secondary nav-link" routerLink="/reports/trade-book"
            routerLinkActive="active">Trade Book</a></li>
          </div>
        </div>
      </li>
    </div>

    @if (content) {
      <div class="position-relative">
        <li class="nav-item dropdown cal-name position-absolute">
          <a class="nav-link dropdown-toggle py-2 me-4" id="navbarDropdownMenuLink" role="button" data-toggle="dropdown"
            aria-haspopup="true" aria-expanded="false">
            <!-- (click)="clickEvent()" -->
            Calendar
          </a>
          <div class="" aria-labelledby="navbarDropdownMenuLink" [ngClass]="toggleMenu? 'mnu-closed' : ''">
            <div class="empty-space-cal"></div>
            <div class="dropdown-menu border-0 shadow mt-n3">
              <li><a class="dropdown-item text-secondary nav-link" routerLink="/calendar/trade-calendar"
              routerLinkActive="active">Trade Calendar</a></li>
              <li><a class="dropdown-item text-secondary nav-link" routerLink="/calendar/economic-calendar"
              routerLinkActive="active">Economic Calendar</a></li>
            </div>
          </div>
        </li>
      </div>
    }

    <!-- <li class="nav-item active dash-name position-absolute">
    <a class="nav-link me-4 text-secondary" routerLink="/dashboard"
    routerLinkActive="active">Dashboard</a>
  </li> -->

  <div class="position-relative">
    <li><a class="text-secondary nav-link refer-offers" routerLink="/refer-offers" routerLinkActive="active">Refer &
    Offers</a></li>
  </div>
  <!-- @if (showdestatLink) { -->
  <div class=" me-1">
    <li><a class="text-secondary nav-link " routerLink="/de-stat" routerLinkActive="active"  ngbTooltip="Convert MF to Demat">MF Conversion
      <span><img src="./assets/images/new_blink_gif.gif" alt="New" width="35"> </span>
    </a></li>
  </div>
  <!-- } -->

  <div class="straight-line "></div>

  <div class="position-relative">
    <li class="nav-item testcolor  dropdown text-end acct-name position-absolute">
      <a class="nav-link  dropdown-toggle me-4 " id="navbarDropdownMenuLink" role="button" data-toggle="dropdown"
        aria-haspopup="true" aria-expanded="false" (click)="clickAccount()" style="position: relative;top: -10px;">
        <i class="bi bi-person ft-24 text-darkblue " style="position: relative;top: 4px;"></i>
      </a>
      <div class="position-relative">
        <div class="nav-item user-id position-absolute">
          <a class="nav-link text-secondary mb-0 mt-n2" style="position: relative;top: -10px;">{{clientId}}</a>
        </div>
      </div>

      <div class="" [ngClass]="toggleMenu? 'mnu-closed' : ''" aria-labelledby="navbarDropdownMenuLink">
        <div class="dropdown-menu border-0 mt-n3  ml-n1 menu-left" style="background: none;top:30px;">
          <!-- <div class="py-3 cursor-pointer testdata" ></div> -->
          <div class="my-account-dropDown border-0 shadow"
            style="background: white;border: 0!important;border-radius: 0.375rem;">
            <!-- <li><a class="dropdown-item text-secondary nav-link ps-2">{{clientName.split(" ")[0] | titlecase}}</a></li> -->

            @if (content) {
              <li><a class="dropdown-item text-secondary nav-link ps-2" routerLink="/account/personal"
              routerLinkActive="active">My Account</a></li>
            }
            <!-- <li><a class="dropdown-item text-secondary nav-link ps-2" href="https://funds.aliceblueonline.com" target="_blank">Payin</a></li> -->
            @if (content) {
              <li><a class="dropdown-item text-secondary nav-link ps-2" (click)="backOfficeLogin()">Back
              Office</a></li>
            }
            <!-- <li *ngIf="brokerage_plan == 'f15client' || content"><a class="dropdown-item text-secondary nav-link ps-2"
          routerLink="/f15" routerLinkActive="active">F15</a></li> -->
          <!-- *ngIf="content" -->
          <!-- <li><a class="dropdown-item text-secondary nav-link ps-2" routerLink="/gift-stock" routerLinkActive="active">Gift
        Stocks</a></li> -->
        @if (content) {
          <li><a class="dropdown-item text-secondary nav-link ps-2" routerLink="/financial-proof"
          routerLinkActive="active">Financial Proof</a></li>
        }
        @if (content) {
          <li><a class="dropdown-item text-secondary nav-link ps-2" routerLink="/mt4-subscription"
          routerLinkActive="active">MT4 Subscription</a></li>
        }
        @if (content) {
          <li><a class="dropdown-item text-secondary nav-link ps-2" routerLink="/mtf"
          routerLinkActive="active"> Margin Trading (MTF) </a></li>
        }
        @if (brokerageEligible) {
          <li><a class="dropdown-item text-secondary nav-link ps-2" routerLink="/brokerage-plan"
          routerLinkActive="active">Brokerage Plan</a></li>
        }
        <li><a class="dropdown-item text-secondary nav-link ps-2" routerLink="/ledger" routerLinkActive="active">Ledger</a>
      </li>
      @if (content) {
        <li><a class="dropdown-item text-secondary nav-link ps-2" href="https://aliceblueonline.com/support"
        (click)="getClevertapSupport()" target="_blank" routerLinkActive="active">Support</a></li>
      }
       @if (showLink) {
        <li><a class="dropdown-item text-secondary nav-link ps-2" routerLink="/trade-journal" routerLinkActive="active">Trader's Journal <span><img src="./assets/images/new_blink_gif.gif" alt="New" width="35"> </span></a></li>
       }
      <li>@if (zerobrokerage) {
        <a class="dropdown-item text-secondary nav-link" routerLink="/zero-brokerage"
        routerLinkActive="active">Zero Brokerage</a>
      }</li>
      @if (content) {
        <li><a class="dropdown-item text-secondary nav-link ps-2" routerLink="/account-closure"
        routerLinkActive="active">Account Closure</a></li>
      }
      @if (content && isDekycShiftingEligible) {
        <li><a class="dropdown-item text-secondary nav-link ps-2"
        routerLink="/client-remapping" routerLinkActive="active">Client Remapping</a></li>
      }
      <!-- <li><a class="dropdown-item text-secondary nav-link ps-2" routerLink="/family-account" routerLinkActive="active">Family Account</a></li> -->
      <!-- *ngIf="content" -->
      <!-- <li ><a class="dropdown-item text-secondary nav-link ps-2" routerLink="/coupon-offer"
    routerLinkActive="active">Coupon & Offers</a></li> -->
    <!-- <li><a class="dropdown-item text-secondary nav-link ps-2" routerLink="/refer-offers" routerLinkActive="active">Refer
  & Offers</a></li> -->
  <!-- <li>
  <a  class="text-secondary nav-link border-bottom ft-16" routerLink="/refer-offers"
  routerLinkActive="active" (click)="closeNav()">Refer & Offers</a>
</li> -->
@if (content) {
  <li><a class="dropdown-item text-secondary nav-link ps-2" routerLinkActive="active"
  (click)="getSubmitSurvey()">Feedback</a></li>
}
<li><a class="dropdown-item text-secondary nav-link ps-2" (click)="logout()">Logout</a></li>
</div>
</div>
</div>
</li>
</div>
</ul>
</div>

<div class="show-mobile mobile-header-title">
  <div class="mobile-header-title-text ft-18 text-darkgrey" [title]="headerName">
    {{headerName}}
  </div>
</div>

<div class="hamburger-menu show-mobile">
  <div class="nav-btn-mobile ft-24" (click)="openNav()">
    <span class="text-dark" [ngClass]="curtainMenu? 'd-none' : ''">
      &#9776;
    </span>
    <span class="ft-30 text-dark" [ngClass]="curtainMenu? 'd-block' : 'd-none'">
      &times;
    </span>
  </div>
  <div class="nav-btn-mobile-inner" [ngClass]="curtainMenu? 'mnu-open' : ''">
    <div class="overlay">
      <!-- <a class="closebtn" (click)="closeNav()">&times;</a> -->
      <div class="overlay-content pb-4">
        <div class="card border-0 px-3">
          <div class="card-inner px-3 py-2 shadow-sm rounded">
            <div class="heading">
              <div class="row align-items-center">
                <div
                  class="col-4 p-0 pt-1 text-end text-light text-center border rounded-circle block ">
                  {{clientName.charAt(0)}}
                </div>
                <div class="heading col-8 ft-18 text-darkgrey">
                  Hi {{clientName | titlecase}} - <span class="ft-15">{{clientId}}</span>
                </div>
                <!-- <div class="row justify-content-center mx-0">
                <div class="col-1 px-0"></div>
                <div class="col-5 px-0 text-secondary ft-12 py-2">
                  <span class="text-secondary ft-12">Client id-</span>
                  {{clientId}}
                </div>
                <div class="col-5 text-secondary ft-12 py-2">
                  <span class="text-secondary ft-12">DP Id-</span>
                  {{dpid}}
                </div>
                <div class="col-10 text-secondary ft-12">
                  <span class="text-secondary ft-12">Demat Id-</span>
                  {{dpAccountNumber}}
                </div>
              </div> -->
            </div>
          </div>
        </div>
      </div>
      <div class="py-4 px-3">
        @if (content) {
          <a class="text-secondary nav-link border-bottom ft-16"
          routerLink="/account/personal" routerLinkActive="active" (click)="closeNav()">My Account</a>
        }
        <a class="nav-link border-bottom text-secondary ft-16" routerLink="/dashboard"
        routerLinkActive="active" (click)="closeNav()">Dashboard</a>

        <li class="showmobile report" (click)="clickPosition()">
          <a class="border-bottom ft-16 min-hgt">Portfolio
            <span class="text-end" [ngClass]=" togglePosition? 'd-none' : ''">
              <i class="bi bi-caret-right-fill text-darkblue fw-bold position-absolute arrow-img"></i>
            </span>
            <span class="text-end" [ngClass]=" togglePosition? '' : 'd-none'">
              <i class="bi bi-caret-down-fill text-darkblue fw-bold position-absolute arrow-img"></i>
            </span>
          </a>
          <ul class="reportsubmenu list-style-none p-0" [ngClass]=" togglePosition? 'mnu-closed' : ''">
            <li class="list-style-none px-0" (click)="closeNav()"><a
              class="text-secondary ft-16 nav-link" routerLink="/portfolio/position"
            routerLinkActive="active">Positions</a></li>
            <li class="list-style-none" (click)="closeNav()"><a class="text-secondary ft-16 nav-link"
            routerLink="/portfolio/holdings" routerLinkActive="active">Holdings</a></li>
            <!-- uat -->
            <li class="list-style-none" (click)="closeNav()"><a class="text-secondary ft-16 nav-link"
              (click)="getClevertapIPOS()" href="https://rise.aliceblueonline.com/ipo"
            target="_blank">IPO's</a></li>
            <!-- prod -->
            <!-- <li class="list-style-none" (click)="closeNav()"><a class="text-secondary ft-16 nav-link"
            (click)="getClevertapIPOS()" href="https://rise.aliceblueonline.com/explore/ipo"
          target="_blank">IPO's</a></li> -->

          <li class="list-style-none" (click)="closeNav()"><a class="text-secondary ft-16 nav-link"
            routerLink="/portfolio/corporate-action" routerLinkActive="active">Corporate
          Action</a></li>
          <li class="list-style-none" (click)="closeNav()"><a class="text-secondary ft-16 nav-link"
          routerLink="/portfolio/tags-analyse" routerLinkActive="active">Tags</a></li>
        </ul>
      </li>
      <li class="showmobile report" (click)="clickEvent()">
        <a class="border-bottom ft-16 min-hgt">Report
          <span class="text-end" [ngClass]=" toggleMenu? 'd-none' : ''">
            <i class="bi bi-caret-right-fill text-darkblue fw-bold position-absolute arrow-img"></i>
          </span>
          <span class="text-end" [ngClass]=" toggleMenu? '' : 'd-none'">
            <i class="bi bi-caret-down-fill text-darkblue fw-bold position-absolute arrow-img"></i>
          </span>
        </a>
        <ul class="reportsubmenu list-style-none p-0" [ngClass]=" toggleMenu? 'mnu-closed' : ''">
          <li class="list-style-none px-0" (click)="closeNav()"><a
            class="text-secondary ft-16 nav-link" routerLink="/reports/pnl"
          routerLinkActive="active">P & L</a></li>
          <li class="list-style-none" (click)="closeNav()"><a class="text-secondary ft-16 nav-link"
          routerLink="/reports/tax-pnl" routerLinkActive="active">Tax P & L</a></li>
          <!-- <li class="list-style-none" (click)="closeNav()"><a class="text-secondary ft-16 nav-link"
          routerLink="/reports/tax-loss-harvesting" routerLinkActive="active">Tax-loss
        harvesting</a></li> -->
        <li class="list-style-none" (click)="closeNav()"><a class="text-secondary ft-16 nav-link"
        routerLink="/reports/download" routerLinkActive="active">Downloads</a></li>
        <li class="list-style-none" (click)="closeNav()"><a class="text-secondary ft-16 nav-link"
        routerLink="/reports/trade-book" routerLinkActive="active">Trade book</a></li>
      </ul>
    </li>

    @if (content) {
      <li class="showmobile report" (click)="clickAccount()">
        <a class="border-bottom ft-16 min-hgt">Calendar
          <span class="text-end" [ngClass]=" toggleAcct? 'd-none' : ''">
            <i class="bi bi-caret-right-fill text-darkblue fw-bold position-absolute arrow-img"></i>
          </span>
          <span class="text-end" [ngClass]=" toggleAcct? '' : 'd-none'">
            <i class="bi bi-caret-down-fill text-darkblue fw-bold position-absolute arrow-img"></i>
          </span>
        </a>
        <ul class="reportsubmenu list-style-none p-0" [ngClass]=" toggleAcct? 'mnu-closed' : ''">
          <li class="list-style-none px-0" (click)="closeNav()"><a
            class="text-secondary ft-16 nav-link" routerLink="/calendar/trade-calendar"
          routerLinkActive="active">Trade Calendar</a></li>
          <li class="list-style-none" (click)="closeNav()"><a class="text-secondary ft-16 nav-link"
            routerLink="/calendar/economic-calendar" routerLinkActive="active">Economic
          Calendar</a></li>
        </ul>
      </li>
    }
    <!-- @if (showdestatLink) { -->
  <div class="position-relative showmobile">
    <li><a class="text-secondary nav-link  ft-16" routerLink="/de-stat" routerLinkActive="active" (click)="closeNav()" ngbTooltip="Convert MF to Demat">MF Conversion
        <span><img src="./assets/images/new_blink_gif.gif" alt="New" width="35"> </span>
    </a></li>
  </div>
  <!-- } -->
    <!-- <a class="text-secondary nav-link border-bottom ft-16" href="https://funds.aliceblueonline.com" target="_blank">Payin</a> -->
    @if (content) {
      <a class="text-secondary nav-link border-bottom ft-16"
      (click)="backOfficeLogin()">Back Office</a>
    }
    <!-- <a *ngIf="brokerage_plan == 'f15client' || content"
    class="text-secondary nav-link border-bottom ft-16" routerLink="/f15" routerLinkActive="active"
  (click)="closeNav()">F15</a> -->
  <!-- <a class="text-secondary nav-link border-bottom ft-16" routerLink="/gift-stock"
routerLinkActive="active" (click)="closeNav()">Gift Stocks</a> -->
@if (content) {
  <a class="text-secondary nav-link border-bottom ft-16" routerLink="/financial-proof"
  routerLinkActive="active" (click)="closeNav()">Financial Proof</a>
}
@if (content) {
  <a class="text-secondary nav-link border-bottom ft-16"
    routerLink="/mt4-subscription" routerLinkActive="active" (click)="closeNav()">MT4
  Subscription</a>
}
@if (content) {
  <a class="text-secondary nav-link border-bottom ft-16" routerLink="/mtf"
  routerLinkActive="active" (click)="closeNav()">Margin Trading (MTF)</a>
}
@if (brokerageEligible) {
  <a class="text-secondary nav-link border-bottom ft-16"
  routerLink="/brokerage-plan" routerLinkActive="active" (click)="closeNav()">Brokerage Plan</a>
}
<a class="text-secondary nav-link border-bottom ft-16" routerLink="/ledger"
routerLinkActive="active" (click)="closeNav()">Ledger</a>
@if (content) {
  <a class="text-secondary nav-link border-bottom ft-16"
    href="https://aliceblueonline.com/support" (click)="getClevertapSupport()" target="_blank"
  routerLinkActive="active">Support</a>
}
<!-- *ngIf="content" -->
<!-- <a  class="text-secondary nav-link border-bottom ft-16" routerLink="/coupon-offer"
routerLinkActive="active" (click)="closeNav()">Coupon & Offers</a> -->
<a class="text-secondary nav-link border-bottom ft-16" routerLink="/refer-offers"
routerLinkActive="active" (click)="closeNav()">Refer & Offers</a>
 @if (showLink) {
<a class="text-secondary nav-link border-bottom ft-16" routerLink="/trade-journal" routerLinkActive="active" (click)="closeNav()">Trader's Journal <span><img src="./assets/images/new_blink_gif.gif" alt="New" width="35"> </span></a>
 }
<!-- <a class="text-secondary nav-link border-bottom ft-14" *ngIf="zerobrokerage" routerLink="/zero-brokerage" routerLinkActive="active" (click)="closeNav()">Zero Brokerage</a> -->
@if (content) {
  <a class="text-secondary nav-link border-bottom ft-16" routerLink="/account-closure"
  routerLinkActive="active" (click)="closeNav()">Account Closure</a>
}
@if (content && isDekycShiftingEligible) {  
  <a class="text-secondary nav-link border-bottom ft-16"
    routerLink="/client-remapping" routerLinkActive="active" (click)="closeNav()">Client
  Remapping</a>
}

<a class="text-secondary nav-link border-bottom ft-16" routerLinkActive="active" (click)="getSubmitSurvey()">Feedback</a>
<a class="text-secondary nav-link border-bottom ft-16" (click)="logout()">Logout</a>
</div>
</div>
</div>
</div>
</div>
</div>
</nav>
</div>
</div>

<ng-template #feedbackTemplate let-c="close" let-d="dismiss">
  <div class="modal-header">
    <div>
      <h4 class="modal-title ft-18 font-bold">Feedback Form</h4>
    </div>
    <div>
      <button type="button" class="btn-close" aria-label="Close" (click)="closeDialog()"></button>
    </div>
  </div>
  <div class="modal-body">
    <form [formGroup]="feedbackForm" autocomplete="off">
      <div class="overflow-height">
        <div class="form-group">
          <label for="exampleFormControlTextarea1" class="ft-12 text-secondary">Provide your valuable feedback
          / suggestions here</label>
          <textarea class="form-control ft-12 text-secondary" id="exampleFormControlTextarea1" rows="3"
          formControlName="questionOne"></textarea>
        </div>
      </div>

      <div class="text-center py-3">
        <button class="btn bg-darkblue text-light ft-14" (click)="submitSurvey()"
        [disabled]="!feedbackForm.valid">Submit</button>
      </div>
    </form>
  </div>
</ng-template>


<ngx-loading [show]="loading">Loading...</ngx-loading>